import { H4, Editorial } from '@xo-union/tk-ui-typography';
import { take } from 'lodash';
import React, { useContext, useState } from 'react';

import { Room, TransientRoomsContext } from '../../contexts/TransientRooms';
import shared from '../hotelPlannerCard.scss';
import Row from '../Row';
import ViewMoreButton from '../ViewMoreButton';
import styles from './style.scss';
import TransientRoomComponent from './TransientRoomComponent';
import HotelPlannerLogo from '../../../../components/PageCard/HotelPlannerLogo';
import HotelPlannerCarousel from '../../../../components/TansientRoomRailCard/HotelPlannerCarousel';
import { HotelPlannerTooltip } from '../../../../components/TansientRoomRailCard';

interface Props {
  onClick: (room: Room) => void;
  useCarousel?: boolean;
}

const cardsToShow = 3;
const Cv2HotelPlannerCard: React.FC<Props> = ({ useCarousel, onClick }) => {
  const rooms = useContext<Room[]>(TransientRoomsContext);
  const [showing, setShowing] = useState(cardsToShow);

  if (rooms.length === 0) {
    return null;
  }

  return (
    <div className={shared.container}>
      <Row className={styles.header}>
        <H4 as="h3" className={styles.headerText}>
          Discover local hotels with
        </H4>
        <HotelPlannerLogo />
        <HotelPlannerTooltip />
      </Row>
      <Editorial className={styles.roomSubtext}>
        Adding these hotels to your website provides custom rates with Engine but does not hold rates or rooms.
      </Editorial>
      {!useCarousel && (
        <>
          <div className={styles.roomWrapper}>
            {take(rooms, showing).map(room => (
              <TransientRoomComponent key={`transientRoom${room.propertyId}`} room={room} onClick={onClick} />
            ))}
          </div>
          <ViewMoreButton rooms={rooms} showing={showing} onClick={(): void => setShowing(v => v + cardsToShow)} />
        </>
      )}
      {useCarousel && (
        <div className={styles.carouselWrapper}>
          <HotelPlannerCarousel onClick={onClick} rooms={rooms} />
        </div>
      )}
    </div>
  );
};

export default Cv2HotelPlannerCard;
